import { Component, OnInit, TemplateRef, Inject, Input, Output, ViewEncapsulation, ViewChild  } from '@angular/core';

import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';

import { formatDate } from '@angular/common';


import { GestockService } from '../services/gestock.service';



@Component({
  selector: 'app-photo-dialog',
  templateUrl: './photo-dialog.component.html',
  styleUrls: ['./photo-dialog.component.css']
})
export class PhotoDialogComponent implements OnInit {
  imageUrl: string;

  imageFile: File | null = null;
  imagePreviewUrl: string = '';


  @ViewChild('spinnerDialog') spinnerDialog: TemplateRef<any>;
  spinnerDialogRef : any ;
  etatreq = "" ;

  retourClientWS : any ;

  samacaabiyoonwii = "" ;

  product : any ;

  imageType : any ;

  constructor(public dialogRef: MatDialogRef<PhotoDialogComponent>,
          private configServer: GestockService, 
            @Inject(MAT_DIALOG_DATA) public data: any,
                         public dialog: MatDialog ,
                         private _adapter: DateAdapter<any>,
                         @Inject(MAT_DATE_LOCALE) private _locale: string) {

    this.imageUrl = data.product.imageUrl || '';
    this.imagePreviewUrl = this.imageUrl ;
    this.product = data.product ;
  }


  ngOnInit(){
    this.samacaabiyoonwii = sessionStorage.getItem("samacaabiyoonwii") ;    
  }


  mettreAjourImageUrlArticleBi(){
    let infoToUpdt = "nataalbi" ;
    let newValue =  this.imagePreviewUrl ;
    let idarticle = this.product.id ;
    let detailsarticle = this.product.detailsarticle ;

    this.openSpinnerDialog() ;
    this.configServer.mettreAjourDetailsArticleBi(this.samacaabiyoonwii, idarticle, infoToUpdt, newValue, detailsarticle).then( (retourbi) => {
      this.closeSpinnerDialog() ;
      this.retourClientWS = retourbi ;
      var statutreq = this.retourClientWS.statutreq;

      if(statutreq==1){
        this.etatreq='successful' ;
        console.log("Mbirr Yi Matna") ;
      }
      else{
        this.etatreq='failed' ;
        console.log("Failed") ;
      }
    }) ;    
  }


  onUrlChange(event: any): void {
    console.log("OnURL Change Called !") ;
    console.log( event ) ;
    this.imageUrl = event;
    this.imagePreviewUrl = this.imageUrl;
  }

  onFileChange(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.imageFile = file;
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.imagePreviewUrl = e.target.result;
      };

      reader.readAsDataURL(file);
    }
  }

  saveImageRemotlymob(){

    console.log(this.imageType) ;

    if(this.imageType == 'file'){
      this.openSpinnerDialog() ;
      this.configServer.sendImageBiCiKaw( this.imagePreviewUrl ).then( (retourbi) => {
        this.closeSpinnerDialog();
        this.retourClientWS = retourbi ;  
        console.log(this.retourClientWS) ; ;
        if(this.retourClientWS.statutreq==1){
          this.imagePreviewUrl = this.retourClientWS.data ;
          this.mettreAjourImageUrlArticleBi() ;
        }
      }) ;
    }else{
        this.mettreAjourImageUrlArticleBi() ;
    }
  }



  save() {
    this.dialogRef.close({ imageUrl: this.imageUrl });
  }

  cancel() {
    this.dialogRef.close();
  }

  openSpinnerDialog() {
    this.spinnerDialogRef = this.dialog.open(this.spinnerDialog);
  }

  closeSpinnerDialog() {
    this.spinnerDialogRef.close();
  }

  close(){
    this.dialogRef.close();    
  }


}
